// Sales quantities are checked against the approved design: a PV sale carries
// panels, a battery sale carries batteries.
const LABELS = { panel: 'panels', battery: 'batteries' }

export function warnIfQuantityDiffersFromDesign(
  design: Record<string, unknown> | undefined,
  product: 'panel' | 'battery',
  value: number
) {
  const designQuantity = design?.[`${product}_quantity`]
  if (designQuantity !== undefined && value !== designQuantity) {
    alert(`The amount of ${LABELS[product]} differs from design`)
  }
}
